import React, { useEffect } from "react";
import InvoiceTable from "./components/InvoiceTable";
import { connect } from "react-redux";
import Button from "components/button";
import { useSearchParams, useNavigate } from "react-router-dom";
import { API_URL } from "services/apiservice";
import apiservice from "services/apiservice";

const Invoices = ({ isLoggedInXero }) => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	useEffect(() => {
		const xeroStatus = searchParams.get("xero");

		if (xeroStatus) {
			apiservice.setLocalStoredValue("xero_status", xeroStatus);
			navigate("/console/invoices", { replace: true });
		}
	}, [searchParams, navigate]);

	return (
		<div>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<InvoiceTable />
			</div>

			<div className="w-full flex gap-4 justify-end text-right my-3">
				{isLoggedInXero != 'connected' && (
					<Button
						type="button"
						className="crud-button"
						onClick={() => {
							window.location.href = `${API_URL}/api/v1/xero/connect`;
						}}
					>
						Connect to Xero
					</Button>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	isLoggedInXero: state.invoice.isLoggedInXero,
});

export default connect(mapStateToProps)(Invoices);